import { CrunchData } from '@dc-shared-web/hooks/api/document/types'
import { UDR_SOLUTION_TYPE_NAME } from '@dc-shared-web/hooks/api/document/constants'
import { FS, FS_CATEGORY } from '@dc-shared-web/lib/trackingConstants'

export function isValidEmail(email: string) {
  const re = /\S+@\S+\.\S+/
  return re.test(email)
}

export const preventDefault = (
  e: React.MouseEvent | React.KeyboardEvent | React.ClipboardEvent
) => {
  e.preventDefault()
  e.stopPropagation()
}

export function capitalizeFirstLetter(val?: string) {
  if (!val) return ''
  val = val.toLocaleLowerCase()
  return val.charAt(0).toUpperCase() + val.slice(1)
}

export function isLineClampActive(textElement: HTMLElement): boolean {
  const containerHeight = textElement.clientHeight
  const scrollHeight = textElement.scrollHeight

  return scrollHeight > containerHeight
}

export function isAlreadyExpanded(
  textElement: HTMLElement,
  unexpandedHeight: number
): boolean {
  const scrollHeight = textElement.scrollHeight
  return scrollHeight > unexpandedHeight
}

export function prepareTrackingEventForCrunchData(crunchData?: CrunchData) {
  const event: {
    crunch_uuid?: string
    solutionType?: string
    documentType?: string
    reviewerRole?: string
  } = {
    crunch_uuid: crunchData?.id || 'Unknown',
    solutionType: crunchData?.crunchType || 'Unknown',
  }

  if (crunchData?.crunchType === UDR_SOLUTION_TYPE_NAME) {
    const docTypeExtra = crunchData?.meta?.crunchExtras?.find(
      (extra) => extra.type === 'doc_type'
    )

    const docTypeDescriptionExtra = crunchData?.meta?.crunchExtras?.find(
      (extra) => extra.type === 'doc_description'
    )

    const docUserOccupationExtra = crunchData?.meta?.crunchExtras?.find(
      (extra) => extra.type === 'user_occupation'
    )

    let docTypeText = docTypeExtra?.value ?? 'Unknown'

    if (docTypeExtra?.value === 'Other' && docTypeDescriptionExtra?.value) {
      docTypeText = `${docTypeExtra.value} - ${docTypeDescriptionExtra.value}`
    }
    return {
      ...event,
      documentType: docTypeText,
      reviewerRole: docUserOccupationExtra?.value ?? 'Unknown',
    }
  }
  return event
}

export function prepareFullStoryEventForCrunchData(crunchData?: CrunchData) {
  const fullStoryEvent = prepareTrackingEventForCrunchData(crunchData)

  if (crunchData?.crunchType === UDR_SOLUTION_TYPE_NAME) {
    return {
      ...fullStoryEvent,
      [FS.REVIEWER_ROLE_CUSTOM_FIELD_NAME]: fullStoryEvent.reviewerRole,
      [FS.DOCUMENT_TYPE_CUSTOM_FIELD_NAME]: fullStoryEvent.documentType,
    }
  }

  return fullStoryEvent
}

export function prepareMultiChecklistData(
  uuid: string,
  deleted: boolean = false
) {
  return {
    name: `Crunch View Checklist ${deleted ? 'Deleted' : 'Added'}`,
    title: document.title,
    path: window.location.pathname,
    page_category: FS_CATEGORY.CRUNCH_VIEW,
    subpage_category: 'Checklist',
    entity_id: uuid,
    entity_type: 'checklist',
  }
}

export function isValidUrl(str: string) {
  try {
    new URL(str)
    return true
  } catch {
    return false
  }
}

export function snakeCaseToCamelCase(str: string) {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

export function validateEmail(email: string): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailRegex.test(email)
}

export const isExternalLink = (url: string): boolean => {
  try {
    const urlObj = new URL(url, window.location.origin)
    const currentLocation = window.location
    // If the url hostname is different from the current location, it's an external link
    return urlObj.hostname !== currentLocation.hostname
  } catch {
    // If URL parsing fails, consider it internal
    return false
  }
}
